<!-- popup add card -->

<app-snackbar [statusMessage]="errorMessage" *ngIf="errorMessage.length>0"></app-snackbar>
<div id="forScroll" class="popup-bg ">
    <div class="popup">
        <div class="popup-content">
            <h3>Add KPI Score</h3>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>

            <form class="form-wrap" [formGroup]="addCard">
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <div class="type-text">
                            <span class="input-title">KPI Type <em> *</em></span>
                        </div>

                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType}">
                            <app-form-select-box [options]="globalService.kpiType" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="addCard" [controlName]="'kpiType_select_name'" [currentSelectedValue]="addCard['controls']['kpiType']['value']"
                                (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                        <div class="invalid-feedback" *ngIf="isSubmitted && addCard['controls']['kpiType'].errors?.required">
                            <sup>*</sup>Please enter your condition
                        </div>
                    </div>
                    <div class="input-wrap">
                        <div class="type-text">
                            <span class="input-title">KPI <em> *</em></span>
                        </div>

                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiList}">
                            <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addCard" [controlName]="'scoreName_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                        <div class="invalid-feedback" *ngIf="isSubmitted && addCard['controls']['scoreName'].errors?.required">
                            <sup>*</sup>Please enter your condition
                        </div>
                    </div>


                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap" *ngIf="(cardName=='benchmarking') && globalService.orderType=='app'">
                        <span class="input-title">Choose Peers</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.appsList}">
                            <app-form-select-box [options]="globalService.appsList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="addCard" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                        <div class="invalid-feedback" *ngIf="isSubmitted && addCard['controls']['peers'].errors?.required">
                            <sup>*</sup>Please enter your condition
                        </div>
                    </div>
                    <div class="input-wrap" *ngIf="(cardName=='benchmarking') && globalService.orderType=='telco'">
                        <span class="input-title">Choose Peers</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.networkList}">
                            <app-form-select-box [options]="globalService.networkList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="addCard" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box>
                        </div>
                        <div class="invalid-feedback" *ngIf="isSubmitted && addCard['controls']['peers'].errors?.required">
                            <sup>*</sup>Please enter your condition
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Speed</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectSpeed}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed" formControlName="speedArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="networktag"
                        [isAllOptionShow]="true"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [formElementName]="addCard" [controlName]="'networktag_select_name'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                            >
                        </app-form-select-box> -->
                        </div>
                    </div>
                </div>

                <div class="input-row input-row-wide">
                    <div class="input-wrap">

                        <span class="input-title">From Date</span>
                        <!-- <div class="dropdown-wrap"> -->
                        <span class="calendar-icon"></span>
                        <div class="datepicker-container">
                            <ng-datepicker formControlName="startDate" (ngModelChange)="dateSelect($event)" name="startDate" [options]="optionsStartDate"></ng-datepicker>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="calendar-icon"></span>
                        <span class="input-title">To Date</span>
                        <!-- <input type="date" [min]="2020-04-02">  -->
                        <ng-container *ngIf="fromdateSelected">
                            <div class="datepicker-container">
                                <ng-datepicker name="endDate" formControlName="endDate" [options]="optionsEndDate"></ng-datepicker>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!fromdateSelected">
                            <div class="datepicker-container">
                                <ng-datepicker formControlName="endDate" [options]="optionsEndDate" name="endDate"></ng-datepicker>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Location</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.dropdownList}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList" formControlName="locationArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="location"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [isAllOptionShow]="true"
                            [formElementName]="addCard" [controlName]="'location_select_name'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                            >
                        </app-form-select-box> -->
                        </div>

                    </div>

                    <div class="input-wrap">
                        <span class="input-title">Device Category</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectDeviceCategory}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory" formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="deviceCategory"
                            [dropDownIdKey]="'deviceCategory_id'" [dropdownLabel]="'list'" 
                            [isAllOptionShow]="true"
                            [formElementName]="addCard" [controlName]="'deviceCategory_select_name'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                            >
                        </app-form-select-box> -->
                        </div>

                    </div>

                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap" *ngIf="globalService.orderType=='app'">
                        <span class="input-title">Network</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="networkArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="network"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [isAllOptionShow]="true"

                            [formElementName]="addCard" [controlName]="'network_select_name'"
                            [addCurrentSelectedValue]="false"
                            (currentSelectionChange)="changeSelection($event)">
                        </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap" *ngIf="globalService.orderType=='telco'">
                        <span class="input-title">Apps</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiselectAppsList" formControlName="apps" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>

                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Application Version</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectAppVersion}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectAppVersion" formControlName="appVersionArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="app_version"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [isAllOptionShow]="true"

                            [formElementName]="addCard" [controlName]="'appversion_select_name'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                            >
                        </app-form-select-box> -->
                        </div>

                    </div>

                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Choose Platform</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectPlatform}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectPlatform" formControlName="platformArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>

                        </div>

                        <!-- <div class="input-wrap input-choice">
                    <span class="input-title">Stream Type</span>                
                    <div class="check-bar">								
                        <div class="check check-radio">
                            <label class="custom-checkbox">
                                <input type="radio" name="stream" formControlName="stream"  value="true" required >
                                <em class="checkmark"></em>
                                <span class="check-text">Live</span>
                            </label>
                        </div>
                        <div class="check check-radio">
                            <label class="custom-checkbox">
                                <input type="radio" name="stream" formControlName="stream" value="false" required>
                                <em class="checkmark"></em>
                                <span class="check-text">VOD</span>
                            </label>
                        </div>								
                    </div>
                </div> -->
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Time window</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectTimeWindow}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectTimeWindow" formControlName="timeWindowArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="timeWindow"
                  [isAllOptionShow]="true"
                        [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [formElementName]="addCard" [controlName]="'timeWindow_select_name'"
                        [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                        >
                    </app-form-select-box> -->
                        </div>

                    </div>

                </div>
                <div class="popup-links">
                    <button class="btn btn-light" (click)="forPopupClose()">close</button>
                    <button class="btn btn-dark" (click)="onSubmit($event)">add score</button>
                </div>
            </form>

        </div>
    </div>
</div>